export enum UpdateFilterType {
  SYNC = 'SYNC',
  NEW = 'NEW',
}
